import React, { useState, useEffect, useContext } from 'react'
import Autocomplete from '@mui/material/Autocomplete'
import TextField from '@mui/material/TextField'
import API from '../../services/API'
import { Avatar, Box, Typography } from '@mui/material'
import { UserContext } from '../../App'

const StaffSelector = ({
  value,
  defaultUserID,
  onChange,
  label,
  multiple,
  noPhoto,
  required,
  disabled,
  helperText,
  freeSolo,
  preventSelectingSelf,
  fullWidth,
  size,
  team,
  clinicalRole,
  shrinkLabel,
  ...props
}) => {
  const [employeeOptions, setEmployeeOptions] = useState([])

  const { user } = useContext(UserContext)

  useEffect(() => {
    if (user) {
      API.get('/employee-search', {
        params: {
          noPhoto: noPhoto ?? false,
          team,
          clinicalRole,
        },
      })
        .then((res) =>
          setEmployeeOptions(
            preventSelectingSelf
              ? res.data.filter((x) => x?.userAccount?._id !== user?._id)
              : res.data,
          ),
        )
        .catch((e) => console.log(e))
    }
  }, [user, team, clinicalRole, noPhoto])

  return (
    <Autocomplete
      {...props}
      fullWidth={fullWidth}
      size={size}
      options={employeeOptions}
      getOptionLabel={(option) => {
        if (option?.userAccount) {
          return `${option?.userAccount?.firstName || ''} ${
            option?.userAccount?.lastName || ''
          }${option?.clinicalRole ? ` (${option.clinicalRole})` : ''}`
        } else {
          return option
        }
      }}
      value={value}
      renderTags={(options) => (
        <Box display="flex" gap={1} flexWrap="wrap">
          {options.map((opt) => {
            if (opt) {
              return (
                <Box
                  display="flex"
                  gap={1}
                  key={opt?._id ?? 1}
                  border="solid 1px rgba(0,0,0,0.24)"
                  borderRadius={1}
                  padding={1}
                >
                  <Avatar
                    src={opt?.userAccount?.photograph}
                    sx={{ width: 24, height: 24 }}
                  />
                  <Typography>
                    {opt?.userAccount?.firstName} {opt?.userAccount?.lastName} (
                    {opt?.clinicalRole})
                  </Typography>
                </Box>
              )
            }
          })}
        </Box>
      )}
      renderOption={(props, option) => {
        const { key, ...rest } = props
        return (
          <Box key={key} display="flex" gap={1} {...rest}>
            <Avatar
              src={option?.userAccount?.photograph}
              sx={{ width: 24, height: 24 }}
            />
            <Typography>
              {option?.userAccount?.firstName} {option?.userAccount?.lastName} (
              {option?.clinicalRole})
            </Typography>
          </Box>
        )
      }}
      multiple={multiple}
      freeSolo={freeSolo}
      onChange={onChange}
      disabled={disabled}
      // onInputChange={onChange}
      // isOptionEqualToValue={(option, value) => option._id === value._id}
      isOptionEqualToValue={(option, value) => option?._id === value?._id}
      renderInput={(params) => (
        <TextField
          {...params}
          label={label}
          helperText={helperText}
          required={required}
          InputLabelProps={{
            shrink: !!shrinkLabel || !!value || !!params.inputProps?.value, // this triggers shrink when typing
          }}
        />
      )}
      getOptionKey={(option) => option._id}
    />
  )
}

export default StaffSelector
